/* CFV NAV V2 — desktop išskleidimai + mobile pomeniu valdymas. Be priklausomybių. */
(function () {
  'use strict';

  /* ---------------- Nuotraukų kėlimas (desktop išskleidimai) ----------------
     <img data-src> neturi src, todėl naršyklė jų nekrauna iš karto. Nuotraukas
     įkeliam, kai pelė/fokusas pasiekia punktą, arba fone po pauzės. */
  function hydrate(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('img[data-src]'), function (img) {
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
    });
  }
  var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1500); };
  idle(function () { setTimeout(function () { hydrate(document.querySelector('[data-cfv-dnav]')); }, 2500); });

  /* ---------------- DESKTOP: išskleidžiami sąrašai ---------------- */
  var items = Array.prototype.slice.call(document.querySelectorAll('[data-cfv-dnav-item]'));

  function setOpen(item, isOpen) {
    var btn = item.querySelector('.cfv-dnav__trigger');
    item.classList.toggle('is-open', isOpen);
    if (btn) btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  function closeAll(except) {
    items.forEach(function (it) {
      if (it !== except) setOpen(it, false);
    });
  }

  items.forEach(function (item) {
    var btn = item.querySelector('.cfv-dnav__trigger');
    var timer = null;

    function open() {
      clearTimeout(timer);
      hydrate(item);
      closeAll(item);
      setOpen(item, true);
    }
    function closeSoon() {
      clearTimeout(timer);
      timer = setTimeout(function () { setOpen(item, false); }, 140);
    }

    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', closeSoon);
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) closeSoon();
    });
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (item.classList.contains('is-open')) setOpen(item, false);
        else open();
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-cfv-dnav-item]')) closeAll();
  });

  /* ---------------- MOBILE: stalčiaus lygiai ---------------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-cfv-mnav]'), function (nav) {
    var views = Array.prototype.slice.call(nav.querySelectorAll('[data-view]'));

    function show(name) {
      views.forEach(function (v) { v.hidden = v.getAttribute('data-view') !== name; });
      nav.classList.toggle('is-sub', name !== 'root');
      var scroller = nav.closest('.m-menu-drawer__content');
      if (scroller) scroller.scrollTop = 0;
    }

    nav.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cfv-open]');
      if (opener) {
        e.preventDefault();
        show(opener.getAttribute('data-cfv-open'));
        return;
      }
      if (e.target.closest('[data-cfv-back]')) {
        e.preventDefault();
        show('root');
      }
    });

    // uždarius stalčių — grįžtam į pirmą lygį
    var drawer = nav.closest('.m-menu-drawer');
    if (drawer && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (!drawer.classList.contains('open')) show('root');
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  });
})();
